import { useState } from 'react'
import { Referral } from '../types/referral'
import { ReferralList } from './ReferralList'
import { ReferralDetail } from './ReferralDetail'
import { ReferralForm } from './ReferralForm'

interface ReferralsTabContentProps {
  patientId: string
  readOnly?: boolean
}

export function ReferralsTabContent({ patientId, readOnly = false }: ReferralsTabContentProps) {
  const [selectedReferral, setSelectedReferral] = useState<Referral | null>(null)
  const [showNewReferral, setShowNewReferral] = useState(false)
  const canWrite = !readOnly

  const handleNewReferral = () => {
    if (!canWrite) return
    setSelectedReferral(null)
    setShowNewReferral(true)
  }

  const handleReferralClick = (referral: Referral) => {
    setSelectedReferral(referral)
    setShowNewReferral(false)
  }

  const handleBack = () => {
    setSelectedReferral(null)
    setShowNewReferral(false)
  }

  if (selectedReferral) {
    return (
      <ReferralDetail
        referralId={selectedReferral.id}
        patientId={patientId}
        onBack={handleBack}
        onUpdate={() => {
          setSelectedReferral(null)
        }}
      />
    )
  }

  if (showNewReferral && canWrite) {
    return (
      <div className="referrals-tab-content">
        <div className="tab-content-header">
          <h2>New Referral</h2>
        </div>
        <ReferralForm
          patientId={patientId}
          onSuccess={() => {
            setShowNewReferral(false)
          }}
          onCancel={handleBack}
        />
      </div>
    )
  }

  return (
    <div className="referrals-tab-content">
      <div className="tab-content-header">
        <h2>Referrals</h2>
        <div className="tab-content-actions">
          <button
            className="btn-primary"
            onClick={handleNewReferral}
            disabled={!canWrite}
            title={canWrite ? undefined : 'Secondary records are read-only'}
          >
            + New Referral
          </button>
        </div>
      </div>
      <ReferralList
        patientId={patientId}
        onReferralClick={handleReferralClick}
      />
    </div>
  )
}
